import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

import {
  AfectacionesCompraConstant,
  OrigenesContabilidadConstant,
  AfectacionesVentaConstant
} from 'constants/index'

import { KeyEventUtil } from 'utils'

const TipoAfectacionFormGroup = ({
  iOrigen,
  iError,
  iTouched,
  fIsSubmitting,
  flagCentroCosto,
  esCuentaActivoFijo,
  aplicaDestino
}) => {
  const onKeyDown = React.useCallback(
    e => {
      if (esCuentaActivoFijo) {
        KeyEventUtil.leaveOnEnterOrTab('modal-select-tipoMovimientoActivo', e)
      } else {
        if (flagCentroCosto) {
          KeyEventUtil.leaveOnEnterOrTab('modal-select-centroCostoNivel1', e)
        } else {
          if (aplicaDestino) {
            KeyEventUtil.leaveOnEnterOrTab('modal-select-cuentaDestino', e)
          } else {
            KeyEventUtil.leaveOnEnterOrTab('modal-nuevoasiento-agregar-button', e)
          }
        }
      }
    },
    [flagCentroCosto, esCuentaActivoFijo, aplicaDestino]
  )

  return (
    <Form.Group>
      <Form.Label text='AFECTACION' htmlFor='modal-select-tipoAfectacion' md={12} />
      <Col md={12}>
        <Field name='tipoAfectacion'>
          {({ field }) => (
            <Form.Select
              {...field}
              id='modal-select-tipoAfectacion'
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              onKeyDown={onKeyDown}
            >
              <option value=''>Seleccionar</option>
              {iOrigen === OrigenesContabilidadConstant.VENTAS ? (
                <>
                  {AfectacionesVentaConstant.__arrayVentasContabilidad.map((x, k) => (
                    <option key={k} value={x.id}>
                      {x.nombre}
                    </option>
                  ))}
                </>
              ) : (
                <>
                  {AfectacionesCompraConstant.__array.map((x, k) => (
                    <option key={k} value={x.id}>
                      {x.nombre}
                    </option>
                  ))}
                </>
              )}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(TipoAfectacionFormGroup)
